import React, { useContext, useRef } from "react";
import { DiamondIcon } from "../Icons/diamond.icon";
import { useIsMounted } from "../../hooks/useIsMounted";
import { StoreContext } from "../../Context/StoreContext";
import { useOnClickOutside2 } from "../../hooks/useOnClickOutside2";

interface Props {
  setIsOpenSendDiamond: React.Dispatch<React.SetStateAction<boolean>>;
  handleSendDiamond: (diamondLevel: number, diamondAmount: number) => void;
  diamondLevel: number;
  moveSectionToBottom?: boolean;
}

export const SendDiamond: React.FC<Props> = (props) => {
  const componentRef = useRef<HTMLDivElement>(null);
  const isMounted = useIsMounted();
  const { state } = useContext(StoreContext);
  const {
    setting: { diamondExchangeLists },
  } = state;

  useOnClickOutside2(componentRef, () => {
    if (isMounted()) {
      props.setIsOpenSendDiamond(false);
    }
  });

  const isDiamondLevelAlreadySent = (diamondLevel: number) => {
    if (props?.diamondLevel && props.diamondLevel >= diamondLevel) {
      return true;
    }
    return false;
  };

  const handleSendDiamond = (p_optionIndex: number) => {
    const diamondLevel = p_optionIndex + 1;
    if (isDiamondLevelAlreadySent(diamondLevel)) return;
    props.handleSendDiamond(diamondLevel, diamondExchangeLists[p_optionIndex]);
  };

  return (
    <>
      <div
        className={`send_diamond_wrapper
            ${props.moveSectionToBottom ? `decide_long_msg_position` : ""} 
          bg-white dark:bg-darkNight drop-shadow-md`}
        ref={componentRef}
        onMouseLeave={() => props.setIsOpenSendDiamond(false)}
      >
        <>
          {diamondExchangeLists?.map((diamond: string, index: number) => {
            return (
              <div
                key={index}
                className={
                  isDiamondLevelAlreadySent(index + 1)
                    ? `send_diamond_item text-primary cursor-not-allowed relative`
                    : `dark:text-frescoWhite send_diamond_item relative`
                }
                onClick={(e) => {
                  e.stopPropagation();
                  handleSendDiamond(index);
                }}
              >
                <p className="diamond_price bg-secondary absolute -top-8">
                  ${diamond}
                </p>
                <DiamondIcon fill="currentColor" />
              </div>
            );
          })}
        </>
      </div>
    </>
  );
};

SendDiamond.defaultProps = {
  moveSectionToBottom: false,
};
